import type { CatalogCsvEntityKind } from '../../domain/csv/csvEntityKinds';

/**
 * Filas de ejemplo por plantilla (valores ficticios; borrá o reemplazá antes de importar).
 * - productos: uno físico y uno de servicio. En categoría poné el nombre exacto de Categorías.
 * - categorías: no hay plantilla de ejemplo (exportá las del rubro).
 */
export function catalogCsvTemplateExampleRows(entity: CatalogCsvEntityKind): string[][] {
  switch (entity) {
    case 'categories':
      return [];
    case 'brands':
      return [
        ['', 'EJEMPLO Marca', 'EJ-MAR', 'https://ejemplo.com', '15', 'si'],
        ['', 'EJEMPLO Marca Inactiva', 'EJ-MAR2', '', '10', 'no'],
      ];
    case 'suppliers':
      return [
        [
          '',
          'EJEMPLO Proveedor SA',
          'EJ-PROV',
          '30-71234567-8',
          'Juan',
          'juan@ejemplo.com',
          '11-4444-5555',
          'Calle Falsa 123',
          'CABA',
          'CABA',
          '1400',
          '30_days',
          '3',
          '5000,00',
          '',
          'Cuenta 001',
          '001',
          'si',
        ],
        // Mínimo: casi todo es opcional, alcanza con el nombre.
        ['', 'EJEMPLO Proveedor Mínimo', 'EJ-PROV2', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'si'],
      ];
    case 'products':
      return [
        // Producto físico (con stock).
        [
          'EJ-SKU-001',
          'EJEMPLO Galletitas',
          '1500,50',
          '',
          'fisico',
          '',
          'Bebidas',
          '',
          'EJEMPLO Marca',
          '',
          'EJEMPLO Proveedor SA',
          'COD-PROV-1',
          'Nota de ejemplo',
          'si',
          // Sin variantes.
          '', '', '', '', '', '', '', '', '',
        ],
        // Servicio (sin stock ni código de barras).
        [
          'EJ-SERV-001',
          'EJEMPLO Recarga Virtual',
          '500',
          '',
          'servicio',
          '',
          'Servicios',
          '',
          '',
          '',
          '',
          '',
          'Servicio sin stock',
          'si',
          // Sin variantes.
          '', '', '', '', '', '', '', '', '',
        ],
        // #712: Producto con variantes (una fila por variante, mismo SKU del parent).
        [
          'EJ-SKU-VAR',
          'EJEMPLO Remera',
          '3000',
          '',
          'fisico',
          '',
          'Indumentaria',
          '',
          '',
          '',
          '',
          '',
          '',
          'si',
          // Variante 1: talle S, color negro.
          'EJ-REM-S-NEG', '', '3000', 'Talle', 'S', 'Color', 'Negro', '', '',
        ],
        [
          'EJ-SKU-VAR',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          // Variante 2: talle M, color negro.
          'EJ-REM-M-NEG', '', '3000', 'Talle', 'M', 'Color', 'Negro', '', '',
        ],
        [
          'EJ-SKU-VAR',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          // Variante 3: talle L, color blanco.
          'EJ-REM-L-BLC', '', '3200', 'Talle', 'L', 'Color', 'Blanco', '', '',
        ],
      ];
    default:
      return [];
  }
}
